export default "__VITE_ASSET__B5sY5F8h__"